module.exports = __webpack_public_path__ + "assets/img/defaultIcon.9a40b327.svg";